export default {
  skip: {
    id: 'onBoarding.skip.button',
    defaultMessage: 'Skip',
  },
};
